<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <!-- <v-flex>
                        <v-card elevation="1">
                            <v-card-title class="pb-0">
                                <h3><strong>Installing a new LICADAS unit</strong></h3>
                            </v-card-title>
                            <v-card-text class="pt-0">
                                <ul>
                                    <li class="mb-2">Coming soon...</li>
                                </ul>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-divider></v-divider> -->
                    <v-flex>
                        <v-card elevation="1">
                            <v-card-title class="pb-0">
                                <h3><strong>Troubleshooting Connectivity Issues</strong></h3>
                            </v-card-title>
                            <v-card-text class="pt-0">
                                <ul>
                                    <li class="mb-2">
                                        Use a multimeter to check the voltage coming out of the AC adapter to verify 12 volts
                                        <ul>
                                            <li class="mb-2">If it is not at 12 volts then replace the AC adapter</li>
                                        </ul>
                                    </li>
                                    <li class="mb-2">
                                        Check the connection of the coax antenna cable to verify the connection at the antenna and box are tight
                                    </li>
                                    <li class="mb-2">
                                        Verify LED sequence (see the LED sequence below)
                                        <ul>
                                            <li class="mb-2">
                                                If the amber light remains solid for a long period of time then the modem is having trouble finding connectivity
                                                with a provider
                                            </li>
                                        </ul>
                                    </li>
                                    <li class="mb-2">
                                        Use the Licadas speed test to get an idea of throughput, be sure to use your mobile phone and make sure your WiFi is
                                        turned off when using the speed test
                                        <ul>
                                            <li class="mb-2">
                                                <a href="#" onClick="window.open('https://www.licadas.com/speed/', '_blank')">https://www.licadas.com/speed/</a>
                                            </li>
                                        </ul>
                                    </li>
                                    <li class="mb-2">Remove the SD card and remove all of the files from it</li>
                                    <li class="mb-2">Check the circuit board for water or cement powder</li>
                                    <li class="mb-2">
                                        If the firmware of the device is less than 4.0.0 then you may get better connectivity upgrading the firmware to the
                                        latest version
                                        <ul>
                                            <li class="mb-2">See the section <strong>How to install firmware</strong> for instructions</li>
                                        </ul>
                                    </li>
                                </ul>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-divider></v-divider>
                    <v-flex>
                        <v-card elevation="1">
                            <v-card-title class="pb-0">
                                <h3><strong>Troubleshooting Sensor Issues</strong></h3>
                            </v-card-title>
                            <v-card-text class="pt-0">
                                <ul>
									<li class="mb-2">
										If the sensor was recently installed and it is reading low but is higher than zero the sensor may need to be burped to remove any air bubbles
									</li>
									<li class="mb-2">
										If the sensor has been installed for any length of time and is reading incorrectly, try pressing the RESET button on the circuit board and wait for the unit to reboot and verify sensor input on the device page
									</li>
                                    <li class="mb-2">
                                        Ensure all of the wires from the pressure transducers are terminated properly and there is no exposed copper hanging out
                                        of the terminals
                                        <ul>
                                            <li class="mb-2">Sometimes strands from the wires will accidentally enter the terminal next to it</li>
                                        </ul>
                                    </li>
									<li class="mb-2">
										Verify the wiring is correct at the M12 as well as the board
									</li>
									<li class="mb-2">
										Ensure that the sensor has not exceeded the torque specification of 35 Nm (newton meter)
									</li>
									<li class="mb-2">
										If the unit has been installed for while
										<ul>
											<li class="mb-2">Examine the wires from the circuit board to the senser to ensure the jacket of the wire has not been pierced or cut</li>
											<li class="mb-2">Examine the wires and pressure transducers for potential water intrusion</li>
										</ul>
									</li>
									<li class="mb-2">
										Move the wires to another port on the terminal strip to check the possibility of a shorted out port
										<ul>
											<li class="mb-2">
												Make sure to reconfigure the product in the dashboard to the new port number
											</li>
										</ul>
									</li class="mb-2">
									<li class="mb-2">
										If the sensor is reading zero, then it is not getting pressure and could be clogged
									</li>
									<li class="mb-2">
										If the sensor is reading high, this means the sensor was overpressure, was tightened past torque spec, or was exposed to water intrusion
									</li>
									<li class="mb-2">As a last resort, replace the pressure transducer</li>
                                </ul>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-divider></v-divider>
                    <v-flex>
                        <v-card elevation="1">
                            <v-card-title class="pb-0">
                                <h3><strong>LED Sequence</strong></h3>
                            </v-card-title>
                            <v-card-text class="pt-0">
                                <div class="mb-4">
                                    When powered on, the LICADAS unit will cycle through various LEDs during an intial test. Then the unit will initiate the
                                    sequence to read the sensors wired to the gateway, connect to a mobile provider, and send data to our servers. The following
                                    definitions may help you to understand what is happening with the device
                                </div>

                                <ul style="list-style-type: none; padding: 0; margin: 0">
                                    <li class="mb-2"><v-chip class="sixtyfour" small color="green" text-color="white">Green</v-chip> - Shows unit has power and is awake</li>
                                    <li class="mb-2">
                                        <v-chip class="sixtyfour" small color="blue" text-color="white">Blue</v-chip> - Device is reading/writing to the SD card
                                    </li>
                                    <li class="mb-2"><v-chip class="sixtyfour" small color="yellow">Yellow</v-chip> - Device is reading the sensors</li>
                                    <li class="mb-2">
                                        <v-chip class="sixtyfour" small color="amber">Amber</v-chip> - When blinking the modem is powering up (lasts a few
                                        seconds) / Solid means the modem is trying to connect to a mobile provider to send data to our servers
                                    </li>
                                    <li class="mb-2"><v-chip class="sixtyfour" small>White</v-chip> - Unit is entering low power so it can sleep</li>
                                </ul>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-divider></v-divider>
                    <v-flex>
                        <v-card elevation="1">
                            <v-card-title class="pb-0">
                                <h3><strong>How to install firmware</strong></h3>
                            </v-card-title>
                            <v-card-text class="pt-0">
                                <ol type="1">
                                    <li class="mb-2">Download the correct version of firmware (FIRMWARE.bin)</li>
                                    <li class="mb-2">Power off the LICADAS unit</li>
                                    <li class="mb-2">Remove the SD card</li>
                                    <li class="mb-2">Place SD card in PC (use a microSD adapter if needed)</li>
                                    <li class="mb-2">Delete all files off of the SD card</li>
                                    <li class="mb-2">Copy the firmware file (FIRMWARE.bin) from PC to the SD card</li>
                                    <li class="mb-2">Remove the SD card from PC and install back into the LICADAS unit</li>
                                    <li class="mb-2">Power the LICADAS unit back on and let the unit run until all LEDs are off (usually 1-5 minutes)</li>
                                    <li class="mb-2">Login to the LICADAS dashboard and verify the new version under the device profile</li>
                                </ol>
                                <v-data-table :items="items || []" :headers="headers" hide-actions class="mt-3">
                                    <template slot="headers" slot-scope="props">
                                        <tr>
                                            <th v-for="header in props.headers" :key="header.text" :style="{ width: header.width, textAlign: 'left' }">
                                                <h4 class="mb-0" color="black">
                                                    <strong>{{ header.text }}</strong>
                                                </h4>
                                            </th>
                                        </tr>
                                    </template>
                                    <template slot="items" slot-scope="props">
                                        <tr>
                                            <td>
                                                <h5>{{ props.item.firmware }}</h5>
                                                <small>{{ props.item.location }}</small>
                                            </td>
                                            <td>
                                                <a :href="props.item.url">
                                                    <v-btn color="primary" @click="downloadFirmware()">Download</v-btn>
                                                </a>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            headers: [
                {
                    text: "Available Firmware Downloads",
                    sortable: false,
                    align: "left",
                    width: "80%",
                },
                {
                    text: "",
                    sortable: false,
                    align: "center",
                    width: "20%",
                },
            ],
            items: [
                {
                    firmware: "Version 4.0.0",
                    location: "Global LTE",
                    url: "https://dashboard.licadas.com/api/public/firmware/global_lte_4_0_0_hologram/FIRMWARE.bin",
                },
            ],
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        next((vm) => {
            vm.finishLoader();
        });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.finishLoader();
        next();
    },
    computed: {},
    methods: {
        downloadFirmware(url) {
            // const link = document.createElement("a");
            // link.href = "https://drive.proton.me/urls/KGH9ZCYR84#7P8gDvm12Cfj";
            // link.download = "licadaspicsum.png";
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);
            window.open(url, "_self");
        },
    },
};
</script>

<style>
.v-chip.sixtyfour,
.v-chip.sixtyfour .v-chip__content {
    width: 64px !important;
    justify-content: center !important;
}
</style>
